<script>
import { defineComponent, ref } from 'vue';
//component
import MainPage from '../component/Layout/MainPage.vue'
import DashboardSlider from '../component/Dashboard/DashboardSlider.vue'
import CategoryList from '../component/CategoryList/CategoryList.vue'

//model
import { CategoryConfigBuilder } from "@/core/Campaign/model/CategoryConfigModel.js";
//feature
import { useLandingFlow } from '../feature/LandingFlowFeature'
import { useLocale } from '../feature/LocaleFeature';
import { useModal } from '../feature/ModalFeature';


export default defineComponent({
  components: {
      MainPage,
      DashboardSlider,
      CategoryList,
  },
  setup() {
    const { query,profile } = useLandingFlow()
    const { localeCode } = useLocale()
    const modal = useModal()
    const categoryConfig = ref(null)
    let dashboardConfig = ref('shopcode_gamestore')

    let loadingStatus = ref({
        dashboard: false,
        categoryList: false,
    })

    const init = () => {
      console.log("query", query.value)
      console.log("profile", profile.value)
      modal.loadingModal.show();  
    }

    const initialCategory = () => {
        var configStr = 'menu_shopcode_topup';
        var categoryConfigBuilder = new CategoryConfigBuilder()
            .setConfig(configStr)
            .setLocale(localeCode.value)
            .create();

        categoryConfig.value = categoryConfigBuilder;
    }

    const onClickBack = () => {
      console.log("onClickBack")
      window.location.replace(query.value.returnUrl)
    }

    const onLoadSuccess = (api) => {
        if (!loadingStatus.value[api]) {
            loadingStatus.value[api] = true;
            let found = false;
            for (let i in loadingStatus.value) {
                if (!loadingStatus.value[i]) {
                    found = true;
                    break;
                }
            }
            if (!found) {
                modal.loadingModal.hide();
            }
        }
    }

    init()
    initialCategory()
    return {
      categoryConfig,
      onClickBack,
      dashboardConfig,
      onLoadSuccess
    }
  },
});
</script>
<template>
    <MainPage title="Game Store" @clickBack="onClickBack()">
        <div class="pt-5 px-5 pb-7">
          <DashboardSlider :apiConfig="dashboardConfig" @onLoaded="onLoadSuccess('dashboard')"></DashboardSlider>
        </div>
        <div class="">
            <CategoryList
                  ref="elemCateList"
                  :categoryConfig="categoryConfig"
                  @onLoaded="onLoadSuccess('categoryList')"
            ></CategoryList>
        </div>
    </MainPage>

</template>
<style lang="scss" scoped>
</style>